import { pollLogic } from './poll.logic';

import { PollHostView, PollProjectorView, PollStudentView } from './PollViews';

import type { ActivityPlugin } from '../../core/types/activity.types';

import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';



export const pollPlugin: ActivityPlugin<'poll'> = {

  ...pollLogic,

  displayName: GAME_MODE_CATALOG.poll.displayName,

  icon: GAME_MODE_CATALOG.poll.icon,

  HostView: PollHostView,

  StudentView: PollStudentView,

  ProjectorView: PollProjectorView,

};



export { demoPollPayload } from './poll.logic';

